import { Injectable } from '@angular/core';

import { ConnectionType } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ConnectionTypeService extends TmsWebBaseEditCreateService<ConnectionType, ConnectionType> {
  constructor() {
    super('ConnectionType', $localize`Connection Type`);
  }
}
